module.exports = __webpack_public_path__ + "img/zoom-moins.6bae3d1c.svg";